import { toast } from 'react-toastify';

export const getToast = ({ status, title, duration = 2 }) => {
  switch (status) {
    case 'success':
      return toast.success(title, {
        position: 'top-right',
        autoClose: duration * 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });

    case 'error':
      return toast.error(title, {
        position: 'top-right',
        autoClose: duration * 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });

    case 'info':
      return toast.info(title, {
        position: 'top-right',
        autoClose: duration * 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });

    default:
      break;
  }
};
